export default __webpack_public_path__ + "static/media/service.90208c05.png";